/* Chart palette and number formatting */
export const CHART_COLORS = [
  "#0F62FE",
  "#FA4D56",
  "#F1C21B",
  "#198038",
  "#FF832B",
  "#1192E8",
  "#82CFFF",
  "#393939",
];

export function formatNum(v, fmt = {}) {
  if (v === null || v === undefined || Number.isNaN(v)) return "—";
  const decimals = fmt.decimals ?? (Math.abs(v) >= 1000 ? 0 : 1);
  const n = Number(v).toLocaleString(undefined, {
    maximumFractionDigits: decimals,
    minimumFractionDigits: 0,
  });
  return `${fmt.prefix || ""}${n}${fmt.suffix || ""}`;
}

export function compact(v) {
  if (v === null || v === undefined) return "—";
  const a = Math.abs(v);
  if (a >= 1e9) return (v / 1e9).toFixed(1) + "B";
  if (a >= 1e6) return (v / 1e6).toFixed(1) + "M";
  if (a >= 1e3) return (v / 1e3).toFixed(1) + "k";
  return Number(v).toLocaleString();
}
